/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { useTranslation } from "react-i18next";

const AddLabelModal = ({
  moduleName = "",
  afterTagModalClose = () => {},
  selectedIds = [],
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
  onModalClose = () => {},
  moduleSlug = "",
}) => {
  const token = localStorage.getItem("token");
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const [tagName, setTagName] = useState("");

  const [tagList, setTagList] = useState([]);
  const [ownedProcessTags, setOwnedProcessTags] = useState([]);
  const [sharedTags, setsharedTags] = useState([]);

  const [tagWarning, setTagWarning] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isCreating, setIsCreating] = useState(false);

  const [errorResponseMessage, setErrorResponseMessage] = useState("");

  // Use a state for local validation errors within the modal
  const [errors, setErrors] = useState({});

  // console.log(moduleName);

  //function for create new tag
  const createNewTagHandler = async () => {
    if (tagName.trim() === "") {
      setErrors({ tagName: t("Please enter a tag name to create.") });
      return;
    }

    try {
      setIsCreating(true);

      let requestUrl =
        url.API_BASE_URL + url.API_CREATE_NEW_TAG + `?token=${token}`;

      let tagData = {
        title: tagName,
        slug: tagName.toUpperCase(),
        isglobal: false,
      };

      const response = await postData(requestUrl, tagData);

      setIsCreating(false);

      // console.log(response);

      if (response.status) {
        setMessageType("success");
        setTagName("");
        getAllTags();
      } else {
        setMessageType("error");
        setErrorResponseMessage(response.message);
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }

    setShowAlert(true);
  };

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_TAGS +
        `?token=${token}&moduleslug=${moduleSlug}`;

      console.log(requestUrl);

      const response = await getData(requestUrl);

      // console.log("response", response);

      if (response.status) {
        setTagList(response.data);
        setOwnedProcessTags(response.ownedtags);
        setsharedTags(response.sharedtags);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // function for set tags
  const tagselectedHandler = (data) => {
    setTimeout(() => {
      setTagName("");
    }, 1000);
    setErrors({}); // Clear any previous errors on interaction

    let prevTags = [...selectedTags];

    const matchedElements = document.querySelectorAll(
      `[data-tagid="${data.value}"]`
    );

    if (prevTags.includes(data.value)) {
      matchedElements.forEach((el) => el.classList.remove("active"));
      // remove from array
      let key = prevTags.indexOf(data.value);
      prevTags.splice(key, 1);
    } else {
      matchedElements.forEach((el) => el.classList.add("active"));
      // add to array
      prevTags.push(data.value);
    }

    setSelectedTags(prevTags);
  };

  //function for save tag to user
  const addRemoveTagHandler = async (action) => {
    if (selectedIds.length > 0) {
      try {
        let requestUrl = url.API_BASE_URL;

        // select request url based on which module this label component is working on
        if (moduleName === "crmleadlist") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_LEAD;
        } else if (moduleName === "blog") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_BLOG;
        } else if (moduleName === "event") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_EVENT;
        } else if (moduleName === "eventmemeber") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_EVENT_MEMBER;
        } else if (moduleName === "successstory") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_SUCCESS_STORY;
        } else if (moduleName === "appuser") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_APP_USER;
        } else if (moduleName === "crmcontact") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_LABEL_CONTACT;
        } else if (moduleName === "crmtemplate") {
          requestUrl = requestUrl + url.API_ADD_TAG_TO_TEMPLATE;
        } else if (moduleName === "companylist") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_COMPANY;
        } else if (moduleName === "companymember") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_COMPANY_MEMBER;
        } else if (moduleName == "group") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_GROUP;
        } else if (moduleName == "survey") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_SURVEY;
        } else if (moduleName == "project") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_PROJECT;
        } else if (moduleName == "projectmemeber") {
          requestUrl = requestUrl + url.API_UPDATE_TAG_PROJECT_MEMBER;
        } else if (moduleName == "tasklog") {
          requestUrl = requestUrl + url.API_ADD_TAG_TASK_LOG;
        } else if (moduleName == "conversation") {
          requestUrl = requestUrl + url.API_ADD_TAG_MAIL;
        } else if (moduleName == "list") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_LIST;
        } else if (moduleName == "task") {
          requestUrl = requestUrl + url.API_ADD_TAG_TASK;
        } else if (moduleName == "challenge") {
          requestUrl = requestUrl + url.API_ADD_LABEL_CHALLENGE;
        } else if (moduleName == "eventagenda") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_AGENDA;
        } else if (moduleName == "challengemember") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_JOB_MEMBER;
        } else if (moduleName == "challengeresponse") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_CHALLENGE_RESPONSE;
        } else if (moduleName == "surveyinvite") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_SURVEY_INVITE;
        } else if (moduleName == "invoice") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_INVOICE;
        } else if (moduleName == "course") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_COURSE;
        } else if (moduleName == "invoicedoc") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_INVOICE_DOC;
        } else if (moduleName == "crmnote") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_NOTE;
        } else if (moduleName == "directaccess") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_DIRECT_ACCESS;
        } else if (moduleName == "product") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_PRODUCT;
        } else if (moduleName == "inventory") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_INVENTORY;
        } else if (moduleName == "faq") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_FAQ;
        } else if (moduleName == "quotation") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_QUOTATION;
        } else if (moduleName == "feedbackrule") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_FEEDBACK_RULE;
        } else if (moduleName == "eventproduct") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_EVENT_PRODUCT;
        } else if (moduleName == "coursemember") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_COURSE_MEMBER;
        } else if (moduleName == "coursesubscriber") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_COURSE_SUBSCRIBER;
        } else if (moduleName == "automationevent") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_AUTOMATION_EVENT;
        } else if (moduleName == "contract") {
          requestUrl = requestUrl + url.API_ADD_REMOVE_TAG_COMPANY_CONTRACT;
        } else if (moduleName == "productcustomerpricing") {
          requestUrl =
            requestUrl + url.API_ADD_REMOVE_TAG_PRODUCT_CUSTOMER_PRICING;
        } else {
          alert("error in module selection. please refresh once");
        }

        setIsUpdating(true);

        let responseArr = [];

        // run a loop for all selected components or checkboxId
        for (let selectedId of selectedIds) {
          let tagUpdateUrl =
            requestUrl +
            `/${selectedId}` +
            `?token=${token}` +
            `&action=${action}`;

          console.log("tagUpdateUrl --------->", tagUpdateUrl);

          console.log("selectedTags --------->", selectedTags);

          const response = await putData(tagUpdateUrl, selectedTags);

          console.log("response in add remove tag-------->", response);

          if (response.status) {
            setMessageType("success");
            responseArr.push(response.data);
          } else {
            setMessageType("error");
          }

          setAlertMessage(response.message);
          setShowAlert(true);
        }

        setIsUpdating(false);
        closeModalhandler();

        // close the modal of addLabel
        let tagModal = document.querySelector("#addLabelModal");
        let modal = bootstrap.Modal.getInstance(tagModal);
        modal.hide();
        setTimeout(() => {
          afterTagModalClose(responseArr);
        }, 1000);
      } catch (error) {
        setShowAlert(true);
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setShowAlert(true);
      setAlertMessage(`Please select data for label execution`);
      setMessageType("error");
    }
  };

  //function for remove active class for selected tags
  const removeActiveClass = () => {
    const liElements = document.querySelectorAll(".tags li a");
    liElements.forEach((li) => {
      li.classList.remove("active");
    });
  };

  // remove active class after close modal
  const resetSelectTags = () => {
    const allTagElements = document.querySelectorAll(".tagblock");
    allTagElements.forEach((el) => el.classList.remove("active"));
  };

  //function for close modal
  const closeModalhandler = () => {
    setTagName("");
    setSelectedTags([]);
    removeActiveClass();
    resetSelectTags();
    setTagWarning(false);
    setErrorResponseMessage("");
    onModalClose();
    // afterTagModalClose();
  };

  useEffect(() => {
    getAllTags();
  }, []);

  return (
    <div
      className="modal fade"
      id="addLabelModal"
      tabIndex="-1"
      aria-labelledby="addLabelModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary icon-md">
                  sell
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-lg text-white mb-0"
                  id="addLabelModalLabel"
                >
                  {t("Tags")}
                </h3>
                <p className="text-white fs-sm mb-0">{t("Manage your tags")}</p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModalhandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              {isUpdating && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
                  style={{ zIndex: 1050 }}
                >
                  <div
                    className="spinner-border text-primary mb-3"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-primary fw-semibold">
                    Processing tags, please wait...
                  </p>
                </div>
              )}
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="mb-3">
                  <label
                    htmlFor="tagInput"
                    className="form-label small fw-semibold"
                  >
                    {t("Search or Create Tag")}
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      id="tagInput"
                      className={`form-control shadow-none ${
                        errors.tagName ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("Search tags or type to create...")}
                      value={tagName}
                      onChange={(e) => {
                        setTagName(e.target.value);
                        if (errors.tagName) {
                          setErrors((prev) => ({ ...prev, tagName: "" }));
                        }
                      }}
                    />
                    <button
                      onClick={createNewTagHandler}
                      type="button"
                      className="btn btn-primary d-flex align-items-center"
                      disabled={isCreating}
                    >
                      {isCreating ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </>
                      ) : (
                        <>
                          <span className="material-symbols-outlined icon-sm">
                            add
                          </span>
                        </>
                      )}
                    </button>
                  </div>
                  {errors.tagName && (
                    <div className="invalid-feedback d-block">
                      {errors.tagName}
                    </div>
                  )}
                </div>
              </form>

              <div
                className="accordion flex-fill"
                id="accordionPanelsStayOpenExample"
                style={{ maxHeight: "300px", overflowY: "scroll" }}
              >
                {/* <!-- ========== Start my tags  Section ========== --> */}
                <div className="accordion-item bg-transparent border-0">
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button bg-transparent p-0 shadow-none"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseTag"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseTag"
                    >
                      {tagList.length === 0 ? (
                        <>
                          {"Add tag above and click"}
                          <span className="d-block material-symbols-outlined icon-sm text-danger ms-1 me-1 mt-1 fw-bold">
                            add
                          </span>
                          {" to save and use"}
                        </>
                      ) : (
                        "My Tags"
                      )}
                    </button>
                  </h3>
                  <div
                    id="panelsStayOpen-collapseTag"
                    className="accordion-collapse collapse show"
                  >
                    <div className="accordion-body p-0 pt-4">
                      <ul
                        className="tags fs-sm d-flex flex-wrap gap-1 mysavedtags"
                        style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        {tagList.map((tag, index) => {
                          if (tagName.length > 0) {
                            return (
                              tag.label
                                .toLowerCase()
                                .includes(tagName.toLowerCase()) && (
                                <li className="tag" key={index}>
                                  <Link
                                    to="#"
                                    onClick={() => tagselectedHandler(tag)}
                                    data-tagid={tag.value}
                                    className="tagblock d-block px-3 py-2 gradient-light cursor-pointer rounded-90"
                                  >
                                    <span>{tag.label}</span>
                                  </Link>
                                </li>
                              )
                            );
                          } else {
                            return (
                              <li className="tag" key={index}>
                                <Link
                                  to="#"
                                  onClick={() => tagselectedHandler(tag)}
                                  data-tagid={tag.value}
                                  className="tagblock d-block px-3 py-2 gradient-light cursor-pointer rounded-90"
                                >
                                  <span>{tag.label}</span>
                                </Link>
                              </li>
                            );
                          }
                        })}
                      </ul>
                      {/* ----- tag list section end ------ */}
                    </div>
                  </div>
                </div>
                {/* <!-- ========== End my tags Section ========== --> */}

                {/* <!-- ========== Start ownedTags Section ========== --> */}
                <div
                  className={
                    ownedProcessTags.length > 0
                      ? "accordion-item bg-transparent border-0"
                      : "d-none"
                  }
                >
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button bg-transparent p-0 shadow-none"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseTwo"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseTwo"
                    >
                      {" "}
                      Process Owned by Me{" "}
                    </button>
                  </h3>
                  <div
                    id="panelsStayOpen-collapseTwo"
                    className="accordion-collapse collapse show"
                  >
                    {ownedProcessTags.map((tag, index) => {
                      return (
                        <div key={index} className="mt-3">
                          <p className="mt-1 fw-semibold text-primary">
                            {tag.processtitle}
                          </p>
                          <ul className="tags fs-sm d-flex flex-wrap gap-1 mt-2 sharedtags">
                            {tag.tags.map((tagData, index) => {
                              return (
                                <li className="tag" key={index}>
                                  <Link
                                    to="#"
                                    onClick={() => tagselectedHandler(tagData)}
                                    data-tagid={tagData.value}
                                    className="tagblock d-block px-3 py-2 gradient-light cursor-pointer rounded-90"
                                  >
                                    <span>{tagData.label}</span>
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      );
                    })}
                  </div>
                </div>
                {/* <!-- ========== End sharedTags Section ========== --> */}

                {/* <!-- ========== Start sharedTags Section ========== --> */}
                <div
                  className={
                    sharedTags.length > 0
                      ? "accordion-item bg-transparent border-0"
                      : "d-none"
                  }
                >
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button bg-transparent p-0 shadow-none"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseThree"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseThree"
                    >
                      {" "}
                      Process Shared With Me{" "}
                    </button>
                  </h3>
                  <div
                    id="panelsStayOpen-collapseThree"
                    className="accordion-collapse collapse show"
                  >
                    {sharedTags.map((tag, index) => {
                      return (
                        <div key={index} className="mt-3">
                          <p className="mt-1 fw-semibold text-primary">
                            {tag.processtitle}
                            {" : "}
                            <span className="text-secondary">{tag.owner}</span>
                          </p>
                          <ul className="tags fs-sm d-flex flex-wrap gap-1 mt-2 sharedtags">
                            {tag.tags.map((tagData, index) => {
                              return (
                                <li className="tag" key={index}>
                                  <Link
                                    to="#"
                                    onClick={() => tagselectedHandler(tagData)}
                                    data-tagid={tagData.value}
                                    className="tagblock d-block px-3 py-2 gradient-light cursor-pointer rounded-90"
                                  >
                                    <span>{tagData.label}</span>
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      );
                    })}
                  </div>
                </div>
                {/* <!-- ========== End sharedTags Section ========== --> */}
              </div>

              {/* Action buttons */}
              <div className="action d-flex justify-content-between gap-4 pt-3 border-top mt-4">
                <button
                  type="button"
                  className="btn btn-primary rounded-pill shadow-sm fw-bold d-flex align-items-center justify-content-center gap-2 w-50 py-2 transition-all"
                  onClick={() => addRemoveTagHandler("1")}
                  disabled={isUpdating}
                >
                  <span className="material-symbols-outlined me-1">add</span>
                  {t("Add Tag")}
                </button>

                <button
                  type="button"
                  className="btn btn-outline-primary rounded-pill d-flex align-items-center justify-content-center gap-2 w-50 py-2 transition-all hover-btn-fill"
                  onClick={() => addRemoveTagHandler("0")}
                  disabled={isUpdating}
                >
                  <span className="material-symbols-outlined me-1">remove</span>
                  {t("Remove Tag")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLabelModal;
